/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAnswerDto
 */
export interface GetAnswerDto {
    /**
     * 
     * @type {string}
     * @memberof GetAnswerDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetAnswerDto
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnswerDto
     */
    codeAnswer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnswerDto
     */
    lange?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnswerDto
     */
    valueOriginal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnswerDto
     */
    criticalType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnswerDto
     */
    valueType?: string | null;
}

/**
 * Check if a given object implements the GetAnswerDto interface.
 */
export function instanceOfGetAnswerDto(value: object): value is GetAnswerDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetAnswerDtoFromJSON(json: any): GetAnswerDto {
    return GetAnswerDtoFromJSONTyped(json, false);
}

export function GetAnswerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAnswerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'value': json['value'] == null ? undefined : json['value'],
        'codeAnswer': json['codeAnswer'] == null ? undefined : json['codeAnswer'],
        'lange': json['lange'] == null ? undefined : json['lange'],
        'valueOriginal': json['valueOriginal'] == null ? undefined : json['valueOriginal'],
        'criticalType': json['criticalType'] == null ? undefined : json['criticalType'],
        'valueType': json['valueType'] == null ? undefined : json['valueType'],
    };
}

export function GetAnswerDtoToJSON(value?: GetAnswerDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'value': value['value'],
        'codeAnswer': value['codeAnswer'],
        'lange': value['lange'],
        'valueOriginal': value['valueOriginal'],
        'criticalType': value['criticalType'],
        'valueType': value['valueType'],
    };
}

